import Vue from 'vue';
import Generic from '@/components/content-management/generic';

Vue.component('generic', Generic);
